<template>
  <slot />
</template>

<script setup lang="ts">
import { computed, provide } from 'vue'

import type { WidgetValue } from '@/types/simplifiedWidget'

import {
  SettingBindingKey,
  isBindableWidgetType
} from '../composables/settingBinding'

const props = defineProps<{
  widgetName: string
  widgetType: string
  widgetValue: WidgetValue
  update: (value: WidgetValue) => void
}>()

if (isBindableWidgetType(props.widgetType)) {
  provide(SettingBindingKey, {
    widgetName: props.widgetName,
    widgetType: props.widgetType,
    value: computed(() => props.widgetValue),
    setValue: (value: WidgetValue) => props.update(value)
  })
}
</script>
